export default __webpack_public_path__ + "static/media/fileSuccess.b78c8406.gif";